import React from 'react';
import { motion } from 'framer-motion';
import Card from './Card';

interface ExperienceItem {
  title: string;
  company: string;
  period: string;
  responsibilities: string[];
}

interface ExperienceProps {
  experiences: ExperienceItem[];
}

const ExperienceCard: React.FC<ExperienceItem & { index: number }> = ({
  title,
  company,
  period,
  responsibilities,
  index,
}) => (
  <motion.div
    className="relative pl-8 pb-12 last:pb-0 border-l border-neutral-200 dark:border-neutral-800 last:border-l-transparent"
    initial={{ opacity: 0, y: 6 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.3, delay: index * 0.04, ease: [0.22, 1, 0.36, 1] }}
  >
    <span className="absolute -left-[4px] top-2 w-2 h-2 bg-accent rotate-45" />
    <div className="mb-2">
      <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-neutral-500 dark:text-neutral-500 mb-1">
        {period}
      </div>
      <h3 className="text-lg font-medium text-neutral-900 dark:text-neutral-50">
        {title}
        <span className="text-neutral-400 dark:text-neutral-600 font-normal"> · </span>
        <span className="text-neutral-700 dark:text-neutral-300">{company}</span>
      </h3>
    </div>
    <ul className="mt-3 space-y-2">
      {responsibilities.map((responsibility, i) => (
        <li key={i} className="flex gap-3 text-[15px] leading-[1.6] text-neutral-600 dark:text-neutral-400">
          <span className="font-mono text-neutral-400 dark:text-neutral-600 mt-0.5 flex-shrink-0">&gt;</span>
          <span>{responsibility}</span>
        </li>
      ))}
    </ul>
  </motion.div>
);

const Experience: React.FC<ExperienceProps> = ({ experiences }) => {
  return (
    <div id="experience">
      <Card title="Experience" index={2}>
        <div>
          {experiences.map((exp, index) => (
            <ExperienceCard key={index} index={index} {...exp} />
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Experience;
